import { isNullish } from './utils';

export function updateURLSearchParam(name: string, value: string) {
  updateURLSearchParams({ [name]: value });
}

export function updateURLSearchParams(updates: { [name: string]: string }) {
  const params = new URLSearchParams(location.search);

  for (const [name, value] of Object.entries(updates)) {
    let valueToSet;

    if (value && value !== '') {
      valueToSet = value;
    } else {
      valueToSet = undefined;
    }

    if (isNullish(valueToSet)) {
      params.delete(name);
    } else {
      params.set(name, valueToSet);
    }
  }

  window.history.replaceState({}, '', `${location.pathname}?${params}`);
}
